<ion-badge color="secondary" *ngIf="isNew">{{ 'new' | translate }}</ion-badge>
